import styled, { css, keyframes } from 'styled-components'

import * as colors from '../../constants/colors'
import * as glyphs from '../../icons/glyphs'

import * as input from './input'

const fadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1;
  }
`

export const Switch = styled.label<{ disabled?: boolean }>`
  cursor: pointer;
  width: 57px;
  height: 28px;
  display: inline-block;
  border-radius: 14px;
  transition: background 0.2s;
  position: relative;

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;

        & + label {
          cursor: not-allowed;
        }
      `
    }
  }}

  &::before {
    content: '';
    display: inline-block;
    height: 22px;
    width: 22px;
    border: 3px solid transparent;
    border-radius: 14px;
    background: ${colors.PRIMARY_GREY_000};
    position: absolute;
    top: 0;
    transition:
      border-color 0.2s,
      left 0.2s;
  }
`

const COLORS = {
  blue: colors.PRIMARY_BLUE_500,
  green: colors.SECONDARY_GREEN_500,
}

export type Color = keyof typeof COLORS

export const Content = styled.div<{ color?: Color; disabled?: boolean }>`
  display: flex;
  position: relative;
  width: fit-content;

  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: not-allowed;
      `
    }
  }}

  ${glyphs.stroke.Check} {
    position: absolute;
    right: 7px;
    top: 7px;
    opacity: 0;
  }

  ${input.HiddenFocusableInput} {
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;

    ${({ disabled }) => {
      if (disabled) {
        return css`
          cursor: not-allowed;
        `
      }
    }}

    &:not(:checked) {
      ${({ disabled }) => {
        if (disabled) {
          return css`
            & ~ ${Switch} {
              background: ${colors.PRIMARY_GREY_500};

              &::before {
                border-color: ${colors.PRIMARY_GREY_500};
                left: 0;
              }
            }
          `
        } else {
          return css`
            & ~ ${Switch} {
              background: ${colors.TEXT_TERTIARY};

              &::before {
                border-color: ${colors.TEXT_TERTIARY};
                left: 0;
              }
            }
          `
        }
      }}
    }

    &:checked {
      ${({ disabled, color = 'green' }) => {
        if (disabled) {
          return css`
            & ~ ${Switch} {
              background: ${colors.PRIMARY_GREY_500};

              &::before {
                border-color: ${colors.PRIMARY_GREY_500};
                left: 29px;
              }

              ${glyphs.stroke.Check} {
                animation: ${fadeIn} 0.5s;
                opacity: 1;
                color: ${colors.PRIMARY_GREY_500};
              }
            }
          `
        } else {
          return css`
            & ~ ${Switch} {
              background: ${COLORS[color]};

              ${glyphs.stroke.Check} {
                animation: ${fadeIn} 0.5s;
                opacity: 1;
                color: ${COLORS[color]};
              }

              &::before {
                border-color: ${COLORS[color]};
                left: 29px;
              }
            }
          `
        }
      }}
    }
  }
`

export const Label = styled.label`
  align-items: center;
  display: flex;
  margin-left: 14px;
`
